import React, { useState } from "react";
import Filters from "./scheduleList";
import { makeStyles } from "@material-ui/core/styles";
import GlobalApi from "./../../Global";
import Colors from "./../../Global/colors";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";
import InputAdornment from "@material-ui/core/InputAdornment";
import Popover from "@material-ui/core/Popover";
import Checkbox from "@material-ui/core/Checkbox";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import TextField from "@material-ui/core/TextField";
import { CircularProgress } from "@material-ui/core";
import search from "../../Assets/search.png";
import filter from "../../Assets/Filter_Icon.png";
import refresh_token from "./../../Global/refresh_token";
import help from '../../Assets/help_icon.png';
import helpAr from "../../Assets/help_icon_ar.png";
import { useTranslation } from "react-i18next";


//Redux
import { useSelector } from "react-redux";


const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 1000,
  },
  resize: {
    padding: "12px",
    fontSize: "12px",
  },
  visuallyHidden: {
    border: 0,
    clip: " t(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
}));

function MySchedule() {
  const classes = useStyles();
  const {t} = useTranslation();
  const language = useSelector((state) => state.languageReducer.language);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [filterMenu1, setFilterMenu1] = React.useState(null);
  const [filterMenu3, setFilterMenu3] = React.useState(null);
  const [templates, setTemplates] = useState([]);
  const [templateFilter, setTemplateFilter] = useState("");
  let company = useSelector((state) => state.companyReducer.company);
  const [selectedTemplates, setSelectedTemplates] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterApplied, setFilterApplied] = useState(false);
  const [searchText, setSearchText] = React.useState("");
  const [schedules, setSchedules] = React.useState([]);
  const [scheduleLoader, setScheduleLoader] = React.useState(false);
  const [templateLoader, setTemplateLoader] = React.useState(false);
  const [appliedFilters, setAppliedFilters]=useState({
    Templates:false,
  })

  React.useEffect(() => {
    fetchSchedule(company);
    getTemplates();
  }, [company?.id]);

  


  const fetchSchedule = (company,_selectedTemplates) => {
    setScheduleLoader(true)
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id:company.id,
      user_id: data.user_id,
      template:JSON.stringify(_selectedTemplates == undefined ? selectedTemplates : _selectedTemplates),
    };

    
    console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/ScheduleAssignee/get_schedule_weekly?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log(response, "[][][][][] DAILY SCHEDULE");
        if (response.status === "Success") {
          if (response.data.length > 0 ){
          //   let sch = [];
          // response.data
          //   .sort((a, b) => new Date(a.filter_date).getTime() - new Date(b.filter_date).getTime())
          //   .map((v, i) => {
          //     let obj = { ...v, filter_date: moment(v.filter_date).format("MMMM DD, YYYY") };
          //     sch.push(obj);
          //     console.log("DATA IN ARRAY", sch);
          //     setState({ Schedule: sch });
          //   });


          setSchedules(response.data);
            
          
          } else if(response.data.length == 0){
            setSchedules([]);
            }
            setScheduleLoader(false)
        } else if (response.error === "jwt expired" || response.error === "invalid token" || response.error === "invalid signature" || response.error === "Unexpected token") {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            fetchSchedule(company);
          }
          setScheduleLoader(false)
        }
      })
      .catch((error) => console.log(error));
    console.log("op");
  };


  const getTemplates = async () => {
    setTemplateLoader(true)

    var retrievedData = localStorage.getItem("UserData");
    var data = JSON.parse(retrievedData);
    var params = {
      company_id: company.id,
      user_id: data.user_id,
    };
    var token = data.token;
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    await fetch(
      GlobalApi +
        "/TemplateShare/get_all_template_shares_for_user?" +
        query ,
      {
        method: "GET",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
      }
    )
      .then((response) => response.json())
      .then(async (res) => {
        if (res.status === "Success") {
          console.log(res.data);
          var result = res.data;
          var templateList = [];
          await result.map((data) => {
            var template = { id: data.id, name: data?.title, checked: false };
            templateList.push(template);
          });

          console.log("templateList??????????????????????????????????",templateList)
          setTemplates(templateList)
          setTemplateLoader(false)
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          if (status) {
          }
        }
      })
      .catch((err) => {
        setTemplateLoader(false)
        console.log(err, "error");
      });
  };




  const handleClick3 = (event) => {
    setFilterMenu1(event.currentTarget);
  };

  const handleClick5 = async (event) => {
    setFilterMenu3(event.currentTarget);
  };

  const handleClose3 = () => {
    setFilterMenu1(null);
  };

  const handleClose5 = () => {
    setFilterMenu3(null);
  };

  const handleDone = () => {
    document.getElementById("schedule1Scroll").scrollTo(0,0);
    console.log(':::::::::::::::::::::::::::::::::::::',selectedTemplates)
    fetchSchedule(company);
    setFilterMenu1(null);
    setFilterMenu3(null);

    if(selectedTemplates.length > 0){
      setAppliedFilters({...appliedFilters,Templates:true})
    }else{
      setAppliedFilters({...appliedFilters,Templates:false})
    }
  };

  const clearTemplateFilter = () => {
    setSelectedTemplates([])
    fetchSchedule(company,[]);
    setFilterMenu1(null);
    setFilterMenu3(null);
  };

  const open = Boolean(filterMenu1);
  const open3 = Boolean(filterMenu3);

  const selectTemplate = (checked, item) => {
    const nextselectedTemplate = checked
      ? [...selectedTemplates, item.id]
      : selectedTemplates.filter((t) => t !== item.id);
    setSelectedTemplates(nextselectedTemplate);
  };

  return <>
      <Grid container justifyContent="center" alignItems="center" spacing={2} style={{backgroundColor: "white", padding: "5px 20px",width:'100%', justifyContent:'space-between', borderRadius: "5px", marginTop: "2px"}}>
        <Grid item xs={12} sm={12} md={4}  style={{alignItems:'center', display:'flex'}}>
          <TextField size="small" autoComplete="off" InputProps={{ startAdornment: <InputAdornment position="start">
                  <img src={search} width={12} />
                </InputAdornment>, endAdornment: <InputAdornment position="end">
                  <Tooltip title={t("Filter Options")}>
                    <img src={filter} width={20} style={{ cursor: "pointer" }} onClick={handleClick3} />
                  </Tooltip>
                </InputAdornment>, classes: { input: classes.resize } }} placeholder={t("Search in existing Schedules")} fullWidth onChange={(e) => setSearchText(e.target.value)} variant="outlined" style={{ width: "80%", backgroundColor: Colors.globalColor5 }} />
                <Tooltip title="Help">
                
                <a href="https://www.uraudits.com/knowledge-center/schedules/" target="blank" style={{color:Colors.globalColor8}}>
                <img src={language == "ar" ? helpAr : help} height={25} style={{marginLeft:'5px',marginTop:'5px'}}/>
                  </a>
               
              </Tooltip>
          {/* =================================popover 1=========================== */}

          <Popover open={open} anchorEl={filterMenu1} onClose={handleClose3} anchorOrigin={{ vertical: "bottom", horizontal: "center" }} transformOrigin={{ vertical: "top", horizontal: "center" }}>
            <div style={{ width: "150px", minHeight: "50px", backgroundColor: "white", borderRadius: "5px", padding: "0px" }}>
              <List component="nav" aria-label="secondary mailbox folders">
                <ListItem button style={{ paddingTop: "2px", paddingBottom: "2px",textAlign:language == "ar" ? "right" :"left" }} onClick={(e) => handleClick5(e)}>
                  <ListItemText primary={t("Templates")} />
                </ListItem>
              </List>
            </div>
          </Popover>

          {/* =================================popover 2=========================== */}
          <Popover open={open3} anchorEl={filterMenu3} onClose={handleClose5} anchorOrigin={{ vertical: "center", horizontal: "right" }} transformOrigin={{ vertical: "center", horizontal: "left" }} style={{ margin: "20px" }}>
            <div style={{ width: "300px", minHeight: "100px", backgroundColor: "white", borderRadius: "5px", padding: "10px" }}>
              <TextField size="small" autoComplete="off" InputProps={{ startAdornment: <InputAdornment position="start">
                      <img src={search} width={12} />
                    </InputAdornment>, classes: { input: classes.resize } }} placeholder={t("Search")} fullWidth variant="outlined" style={{ backgroundColor: Colors.globalColor5 }} value={templateFilter} onChange={(e) => setTemplateFilter(e.target.value)} />

              <br />
              <p className="label2" style={{ marginTop: "20px", fontSize: 14, fontWeight: "bold" }}>
                {t("Templates")}
              </p>
              <div className="scrollbarShow2" style={{ maxHeight: "100px", overflowY: "scroll" }}>
                {templateLoader && <div style={{ textAlign: "center" }}>
                    <CircularProgress style={{ color: Colors.globalColor8 }} />{" "}
                  </div>}

                {!templateLoader && <>
                    {templates
                      .filter((word) =>
                        word.name
                          .toLowerCase()
                          .includes(templateFilter.toLowerCase())
                      ).sort((a, b) => a.name.localeCompare(b.name))
                      .map((item, index) => {
                        if(item.name){
                          return <span style={{ display: "block" }}>
                          <Checkbox className="filterCheckbox" style={{ color: Colors.globalColor8 }} onChange={(e) => selectTemplate(e.target.checked, item)} defaultChecked={selectedTemplates.indexOf(item.id) > -1} />
                          <p className="label2" style={{ display: "inline", marginTop: "0px", fontSize: 12, textTransform: "capitalize", fontWeight: "normal" }}>
                            {<Tooltip title={item?.name ? item?.name : ""}>
                                <p style={{ display: "inline", margin: 0 }}>
                                  {item?.name.slice(0, 15) +
                                    (item?.name.length > 15 ? "..." : "")}
                                </p>
                              </Tooltip>}
                          </p>
                        </span>;
                        }
                        
                      })}
                  </>}
              </div>

              <hr style={{ borderTop: "1px solid #dadada", borderBottom: "none", marginTop: 10, width: "100%", marginBottom: 20 }} />
              <Button className="ctBtn" onClick={() => handleDone()}>
                {/* //  onClick={() => onSelectUser()} */}
                {t("Done")}
              </Button>
            </div>
          </Popover>
        </Grid>
        {selectedTemplates.length > 0 && appliedFilters.Templates && <Grid item xs={12} sm={12} md={8}>
            <div style={{ justifyContent: "center", alignItems: "center", cursor: "pointer" }}>
              <div style={{ overflow: "hidden", border: "1px solid #043077", backgroundColor: Colors.globalColor9, color: "#043077", height: "100%", borderRadius: "5px", display: "inline-flex", alignItems: "center" }}>
                <div style={{ display: "inline", borderRight: "1px solid #043077", padding: "5px", backgroundColor: Colors.globalColor9 }}>
                  {templates
                    .filter((v) => v.id == selectedTemplates[0])[0]
                    .name.slice(
                      0,
                      20
                    ) + "..."} {selectedTemplates.length > 1 && <>
                      {" "}
                      +{selectedTemplates.length - 1}{" "}
                    </>}
                </div> <div onClick={() => clearTemplateFilter()} style={{ backgroundColor: Colors.globalColor9, display: "inline", padding: "0px 5px", cursor: "pointer" }}>
                  x
                </div>
              </div>
            </div>
          </Grid>}
      </Grid>

      <div style={{ height: "54vh", padding:window.innerWidth > 500 ? "0px 10px 10px 10px" : "5px", overflow: "hidden", display: "flex", flexDirection: "column" }}>
        <div style={{ overflow: "hidden" }}>
          <Filters schedules={schedules} scheduleLoader={scheduleLoader} searchText={searchText} />
        </div>
      </div>
    </>;
}

export default MySchedule;
